import React from 'react'
import './Note.css' 



export default class Note extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            status : false,
            currentNote : this.props.name
        }
        
        //creates a ref to access the audio element at dom level
        this.ref = new React.createRef();
        this.handlePlay = this.handlePlay.bind(this);
        this.handleKeyPlay = this.handleKeyPlay.bind(this)
        
    }
     //I need to re-render the component in order to 
    // get the ref object after the audio element has 
    //been rendered or it will be null
    componentDidMount(){
            document.addEventListener('keydown', this.handleKeyPlay);
            this.forceUpdate()

}
    handleKeyPlay(ev){
            if (ev.keyCode === this.props.keycode){
                 this.handlePlay()
    }
}
    handlePlay(){
            if (this.props.powerBtn){
         
                 this.props.handleDisplay(this.state.currentNote);  
                 this.ref.current.volume = this.props.volume;    
                 this.ref.current.currentTime = 0;
                 this.ref.current.play();
                 this.setState({
                                status: true
                             });
                setTimeout(() => this.setState({
                                                 status: false
                                                }),100);
    
    }
 }
    
   
    render(){
       
             return (
                     <div className={this.state.status ? this.props.classnameDown : this.props.classnameUp}>
                         <audio ref={this.ref} src={this.props.note}></audio>
                         <div className="button" onClick={this.handlePlay}>
                             <span className="key-char">{this.props.keyb}</span>  
                         </div>
                     </div>
    )
   }
}